module.exports = __webpack_public_path__ + "static/img/mc.b4f4b90d.svg";